// extracted by mini-css-extract-plugin
module.exports = {"Title":"_28pkxhAcQM6XBMvQPC1cFz","Divider":"_31r4hbm_q2qdGL0TIMvegG"};